import React, { Component } from "react";
import AuthService from "../../services/auth";
import PlayerCard from "../../components/PlayerCard";
import LoadingMask from "../../components/LoadingMask";

import "./styles.css";

class Votes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userVotes: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    AuthService.getUserVotes().then((response) => {
      this.setState({
        userVotes: response.data.data,
        isLoading: false,
      });
    });
  }

  render() {
    const { userVotes, isLoading } = this.state;

    return (
      <div className="PageContainer">
        <div className="VoteContainer">
          {isLoading && <LoadingMask />}
          <h2 className="Votes__title">Voto registrado com sucesso</h2>
          <h4 className="Votes__subtitle">Obrigado por participar</h4>

          <div className="Votes">
            {userVotes.map((player) => (
              <PlayerCard key={player.playerId} player={player} />
            ))}
          </div>
          <a className="Button Vote-btn" href="/players">
            🔁Votar novamente
          </a>
        </div>
      </div>
    );
  }
}

export default Votes;
